import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, Observable, Subject, switchMap } from 'rxjs';
import { Iconstant } from 'src/app/core/constants/constant';
import { LeaderboardService } from 'src/app/core/services/leaderboard/leaderboard.service';
import { MaterialModule } from 'src/app/material.module';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { PropertyAddComponent } from 'src/app/shared/pages/property-management/property-add/property-add.component';
import { PropertyDetailComponent } from 'src/app/shared/pages/property-management/property-detail/property-detail.component';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  serialNumber?: number;
  agentName?: string;
  email?: string;
  phoneNumber?: string;
  agentType?: string;
  assignedLeads?: string;
  status?: string;
  action?: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'Active' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'Active' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Active' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Active' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'Active' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'Active' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'Active' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'Active' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'Active' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Active' },
];

@Component({
  selector: 'app-leader-board-list',
  imports: [MaterialModule, CommonModule, FormsModule],
  templateUrl: './leader-board-list.component.html',
  styleUrl: './leader-board-list.component.scss'
})
export class LeaderBoardListComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = ['rank', 'title', 'country', 'punchCount', 'status'];
  dataSource:any = [];
  leaderBoardList: any = [];
  searchItem: any;
  totalCount: any;
  pageSize: number = 10;
  pageIndex: number = 0;
  selectedDuration: any = '';
  constant:any  =  Iconstant;



  private searchTerms = new Subject<string>();
  products$: Observable<any>;


  constructor(
    private dialog: MatDialog,
    private leaderboardService: LeaderboardService
  ) { }

  ngOnInit() {
    this.getAllLeaderBoardList();
    this.getLeaderBoardListBySearch();
  }

  getLeaderBoardListBySearch() {
    this.searchTerms.pipe(
      debounceTime(800),               // wait 300ms after each keystroke
      distinctUntilChanged(),          // ignore if next search term is same as previous
      switchMap(term => {
        this.pageIndex = 0;
        if (this.paginator) this.paginator.firstPage();
        return this.leaderboardService.getLeaderBoardListBySearch(term, this.pageIndex + 1, this.pageSize);
      })
    ).subscribe((res: any) => {
      if (res.isSuccess) {
        this.applyResponse(res);
      }
    })
  }

  search(event: any) {
    const query = event.target.value;
    this.searchItem = query;
    this.searchTerms.next(query);
  }

  getLeaderBoardByDuration(duration: any) {
    this.selectedDuration = duration;
    this.pageIndex = 0;
    if (this.paginator) this.paginator.firstPage();
    this.leaderboardService.getLeaderBoardRanking(duration, this.pageIndex + 1, this.pageSize).subscribe({
      next: (res: any) => {
        if (res.isSuccess) {
          this.applyResponse(res);
        }
      },
      error: (error: any) => {
        console.log('qwertyui', error)
      }
    })
  }

  /**
   * Handle page change event from paginator - fetches the requested page from the server.
   * @param event
   */
  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    const hasSearch = this.searchItem && this.searchItem.trim().length > 0;
    const obs = hasSearch
      ? this.leaderboardService.getLeaderBoardListBySearch(this.searchItem, this.pageIndex + 1, this.pageSize)
      : this.leaderboardService.getLeaderBoardRanking(this.selectedDuration, this.pageIndex + 1, this.pageSize);

    obs.subscribe({
      next: (res: any) => {
        if (res.isSuccess) {
          this.applyResponse(res);
        }
      },
      error: (error: any) => {
        console.log('qwertyui', error)
      }
    });
  }

  private applyResponse(res: any) {
    this.leaderBoardList = res.items || [];
    this.dataSource = res.items || [];
    this.totalCount = res.total ?? res.totalRecords ?? res.count ?? this.leaderBoardList.length;
  }

  getAllLeaderBoardList() {
    this.leaderboardService.getAllLeaderBoardList(this.pageIndex + 1, this.pageSize).subscribe({
      next: (res: any) => {
        if (res.isSuccess) {
          this.applyResponse(res);
        }
      },
      error: (error: any) => {
        console.log('qwertyui', error)
      }
    })
  }

  openAddModel() {
    const dialogRef = this.dialog.open(PropertyAddComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  viewDetail(detail: any) {
    const dialogRef = this.dialog.open(PropertyDetailComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  edit(data: any, panel: any) {
    const dialogRef = this.dialog.open(PropertyAddComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        panel
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  deleteItem(data: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '250px',
      panelClass: 'confirm-dialog',
      position: {
        top: '10px', // Align to the top
        // left: '40%', // Center horizontally
      },
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          yes: 'yes',
          no: 'no'
        }
      },
    }).afterClosed().subscribe((result: any) => {
      console.log('Dialog closed with result:', result);
      if (result === true) {
        // Perform delete operation or further logic
      }
    });
  }


  onActionSelect(event: any) { }

  onAction1(element: any) { }
}
